// src/hooks/products/useRestoreAllProducts.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllProducts } from "../../api/apiProducts";
import parseError from "../../utils/parseError";

const useRestoreAllProducts = () => {
    const queryClient = useQueryClient();

    const {
        mutate: restoreAllProductsMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: restoreAllProducts,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["products"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore products");
        },
    });

    return {
        restoreAllProducts: restoreAllProductsMutate,
        isRestoreAll: isPending || isLoading,
    };
};

export default useRestoreAllProducts;
